<template>
  <div v-if="isDemo && !isLocked" class="fixed top-0 right-0 z-[60] m-4">
    <div class="bg-red-600 text-white px-4 py-2 rounded-lg shadow-lg flex items-center gap-3 backdrop-blur-sm bg-opacity-90 border border-red-500">
      <div class="flex flex-col items-end">
        <span class="text-[10px] uppercase font-bold tracking-wider opacity-80">Demo Time Remaining</span>
        <span class="text-xl font-mono font-bold">{{ formatTime(remainingTime) }}</span>
      </div>
      <div class="h-8 w-px bg-white/20"></div>
      <div class="animate-pulse">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted, onUnmounted } from 'vue'
import { useDemoTimer } from '@/composables/useDemoTimer'

const { isDemo, isLocked, remainingTime, formatTime, startTimer, stopTimer } = useDemoTimer()

onMounted(() => {
  startTimer()
})

onUnmounted(() => {
  stopTimer()
})
</script>
